module.exports = __webpack_public_path__ + "6ad396399f4022ccd1616cf11d0985be.woff";